import { useEffect } from "react";
import { useNavigate } from "react-router-dom";
import { useAuth } from "@/context/AuthContext";

/**
 * Wraps a route and enforces auth + (optional) seller role.
 * Renders children only when allowed; redirects otherwise.
 */
export default function ProtectedRoute({ children, requireSeller = false }) {
  const { user, loading } = useAuth();
  const navigate = useNavigate();

  useEffect(() => {
    if (loading) return;
    if (!user) {
      navigate("/auth?mode=signin", { replace: true });
      return;
    }
    if (requireSeller && !user.is_seller) {
      navigate("/explore", { replace: true });
    }
  }, [user, loading, requireSeller, navigate]);

  if (loading) {
    return (
      <div className="min-h-screen flex items-center justify-center bg-[var(--paper)]">
        <div className="mono text-[11px] tracking-[0.2em] uppercase text-[var(--ink3)]">◆ Loading…</div>
      </div>
    );
  }
  if (!user) return null;
  if (requireSeller && !user.is_seller) return null;
  return children;
}
